import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=b8c2ef36"
import script from "./addQuestion.vue?vue&type=script&lang=js"
export * from "./addQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports